/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateTokenRequestDto
 */
export interface ValidateTokenRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ValidateTokenRequestDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidateTokenRequestDto
     */
    token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidateTokenRequestDto
     */
    $type?: ValidateTokenRequestDtoTypeEnum;
}


/**
 * @export
 */
export const ValidateTokenRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationAccountDtoValidateTokenRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Account.Dto.ValidateTokenRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ValidateTokenRequestDtoTypeEnum = typeof ValidateTokenRequestDtoTypeEnum[keyof typeof ValidateTokenRequestDtoTypeEnum];



/**
 * Check if a given object implements the ValidateTokenRequestDto interface.
 */
export function instanceOfValidateTokenRequestDto(value?: unknown): value is ValidateTokenRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ValidateTokenRequestDtoTypeEnum)[0];
}

export function ValidateTokenRequestDtoFromJSON(json: any): ValidateTokenRequestDto {
    return ValidateTokenRequestDtoFromJSONTyped(json, false);
}

export function ValidateTokenRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateTokenRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'token': json['token'] == null ? undefined : json['token'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ValidateTokenRequestDtoToJSON(value?: ValidateTokenRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'email': value['email'],
        'token': value['token'],
        '$type': value['$type'],
    });
}

